import { StyleSheet } from 'react-native'

import { DS } from '../../design-system'

export const styles = StyleSheet.create({
  submitGradientButton: {
    borderRadius: DS.spacing[24],
    width: '100%',
    height: 48
  },

  submitButton: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
})
